import { Form } from 'antd'
import React, { useMemo } from 'react'

import UploadImage from '../uploadImage'

import type { UploadImageRef } from '../uploadImage'
import type { MusicGeneratorFormValuesNew } from '@/pages/tad.ai/ai-music-generator/_types/form'
import type { FormInstance } from 'antd/lib'

import { ImageDisplayStatus } from '@/components/ImageDisplay/type'

interface LeftImageUploadProps {
  form: FormInstance<MusicGeneratorFormValuesNew>
  imageUrl?: string
  imageDisplayStatus: ImageDisplayStatus
  setImageDisplayStatus: (status: ImageDisplayStatus) => void
  uploadImageRef: React.RefObject<UploadImageRef>
  isStream: boolean
  onChangeFormValues: (values: Partial<MusicGeneratorFormValuesNew>) => void
}

export const LeftImageUpload = (props: LeftImageUploadProps) => {
  const {
    form,
    imageUrl,
    imageDisplayStatus,
    setImageDisplayStatus,
    uploadImageRef,
    isStream,
    onChangeFormValues,
  } = props

  const disableUploadImage = useMemo(() => {
    return (
      (!!imageUrl && imageUrl.startsWith('http')) ||
      imageDisplayStatus === ImageDisplayStatus.LOADING
    )
  }, [imageUrl, imageDisplayStatus])

  const handleRemoveImage = () => {
    form.setFieldValue('imageUrl', '')
    onChangeFormValues({
      imageUrl: '',
    })
    setImageDisplayStatus(ImageDisplayStatus.EMPTY)
    uploadImageRef.current?.abortUpload()
  }

  return (
    <Form.Item name='imageUrl' className='ml-4 mt-3'>
      <UploadImage
        ref={uploadImageRef}
        className={isStream ? 'cursor-pointer opacity-40' : 'cursor-pointer'}
        disabled={disableUploadImage}
        imageUrl={imageUrl}
        imageDisplayStatus={imageDisplayStatus}
        onRemove={handleRemoveImage}
        onChange={(status: ImageDisplayStatus, url?: string) => {
          if (status === ImageDisplayStatus.LOADED) {
            form.setFieldValue('imageUrl', url)
            onChangeFormValues({
              imageUrl: url,
            })
          }
          setImageDisplayStatus(status)
        }}
      />
    </Form.Item>
  )
}
